import React, {forwardRef, useEffect, useRef, useState} from "react";
import './PopupLatexBlock.css'
import {t} from "i18next";
import {MAX_Z_INDEX} from "@/Const";
import {createPortal} from "react-dom";

const PopupLatexBlock = forwardRef((props:{position:any,handleBlur:any,inputDone:any,onChange:any,defaultContent:any}, ref)=>{

    const [metaData, setMetaData] = useState('');

    let latexBlockRef = useRef(null);

    useEffect(() => {
        setTimeout(()=>{
            latexBlockRef.current?.focus()
        },100)
        setMetaData(props.defaultContent)
    }, []);

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            props.inputDone();
        }
    }

    return createPortal(
        <div className='popup-latex-block' style={{left: props.position.left,
            top: props.position.top,zIndex:MAX_Z_INDEX+999}} contentEditable={false} onBlur={props.handleBlur}>
            <textarea ref={latexBlockRef}
                value={metaData}
                      style={{background:'transparent',color:'var(--text-color)'}}
                onChange={(event)=> {
                    setMetaData(event.target.value);
                    props.onChange(event.target.value);
                }}
                id="input" className="input" placeholder="Enter Latex"
                onKeyDown={handleKeyDown}
            ></textarea>
                <button id="doneBtn" className="done-btn" onClick={props.inputDone}>{t("Done")}</button>
        </div>
    ,document.body)
})

export default PopupLatexBlock;